import { ComponentPropsWithoutRef } from 'react';

export function Table(props: ComponentPropsWithoutRef<'table'>) {
  return (
    <div className="border-grayscale100 rounded-18 border">
      <table {...props} className="w-full" />
    </div>
  );
}
